const features = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07b39" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C12 2 16 7 16 11.5C16 13.985 14.209 16 12 16C9.791 16 8 13.985 8 11.5C8 7 12 2 12 2Z" />
        <path d="M12 11C12 11 13.5 13 13.5 14.5C13.5 15.328 12.828 16 12 16C11.172 16 10.5 15.328 10.5 14.5C10.5 13 12 11 12 11Z" fill="#e07b39" stroke="none"/>
      </svg>
    ),
    title: "100% Soy Wax",
    description: "Clean burning eco-friendly materials",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07b39" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12,6 12,12 16,14" />
      </svg>
    ),
    title: "50+ Hour Burn Time",
    description: "Long-lasting fragrances for your home",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07b39" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="2" />
        <path d="M16 8l4 1 3 3v4h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    ),
    title: "Eco-Packaging",
    description: "Reusable glass and minimal waste",
  },
];

export default function FeaturesBar() {
  return (
    <section
      className="w-full"
      style={{
        background: "#fff",
        borderBottom: "1px solid #f0ebe3",
        padding: "28px 6%",
      }}
    >
      <div
        className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16"
        style={{ maxWidth: "900px", margin: "0 auto" }}
      >
        {features.map(({ icon, title, description }, i) => (
          <div key={i} className="flex items-center gap-4">
            <div
              className="flex items-center justify-center rounded-full flex-shrink-0"
              style={{
                width: "42px",
                height: "42px",
                background: "rgba(224,123,57,0.08)",
              }}
            >
              {icon}
            </div>
            <div>
              <div
                className="font-semibold text-xs tracking-wide"
                style={{ fontFamily: "Georgia, serif", color: "#1a1a1a", fontSize: "13px" }}
              >
                {title}
              </div>
              <div
                className="text-xs"
                style={{ fontFamily: "Georgia, serif", color: "#888", marginTop: "2px" }}
              >
                {description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}